import {
  createContext,
  type ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";

interface IVolumeHoverContextType {
  hoveredIndex: number | null;
  setHoveredIndex: (index: number | null) => void;
}

const VolumeHoverContext = createContext<IVolumeHoverContextType | null>(null);

export const VolumeHoverProvider = ({ children }: { children: ReactNode }) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const values = useMemo(
    () => ({ hoveredIndex, setHoveredIndex }),
    [hoveredIndex]
  );

  return (
    <VolumeHoverContext.Provider value={values}>
      {children}
    </VolumeHoverContext.Provider>
  );
};

export const useVolumeHover = (): IVolumeHoverContextType => {
  const context = useContext(VolumeHoverContext);

  if (!context) {
    throw new Error("useVolumeHover must be used within a VolumeHoverProvider");
  }

  return context;
};
